// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { CustomProductUnitOfMeasure } from "@conklin/Overrides/Widgets/Header/SearchInput";
import { parseBoolean } from "@conklin/XDL/Utilities";
import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { chain, RequestDataFromApi } from "@insite/client-framework/Store/CommonHandlers/GetAutocompleteModel";
import loadRealTimePricing from "@insite/client-framework/Store/CommonHandlers/LoadRealTimePricing";
import { ProductAutocompleteItemModel, UnitOfMeasureModel } from "@insite/client-framework/Types/ApiModels";

const getUnitOfMeasure = (unitOfMeasures: string) => {
    const customUnitOfMeasures = JSON.parse(unitOfMeasures || "[]") as CustomProductUnitOfMeasure[];
    const xUnitOfMeasures: UnitOfMeasureModel[] = customUnitOfMeasures.map(({ productUnitOfMeasureId, ...uom }) => ({
        id: productUnitOfMeasureId,
        ...uom,
    }));
    const unitOfMeasure = xUnitOfMeasures.find(o => !!o.isDefault)?.unitOfMeasure || "EA";
    return unitOfMeasure;
};

export const UpdatePrice: typeof RequestDataFromApi = props => {
    if (!props.apiResult?.products || props.apiResult.products.length === 0) {
        return;
    }
    const realTimePayload: any[] = [];
    props.apiResult?.products.forEach((product: ProductAutocompleteItemModel) => {
        if (!parseBoolean(product.properties?.hasVariants)) {
            realTimePayload.push({
                productId: product.id! || "",
                unitOfMeasure: getUnitOfMeasure(product.properties.unitOfMeasures) || "",
                qtyOrdered: product.properties["minimumOrderQty"] || "1",
            } as any);
        }
    });
    if (realTimePayload.length) {
        props.dispatch(
            loadRealTimePricing({
                productPriceParameters: realTimePayload,
                onComplete: (realTimePricingProps: any) => {
                    if (realTimePricingProps?.apiResult) {
                        realTimePricingProps.apiResult.realTimePricingResults?.forEach((pricing: any) => {
                            props.apiResult.products = props.apiResult.products!.map(product => {
                                if (
                                    product.id === pricing.productId &&
                                    getUnitOfMeasure(product.properties.unitOfMeasures) === pricing.unitOfMeasure
                                ) {
                                    product.properties.pricing = pricing;
                                }
                                return product;
                            });
                        });
                    } else if (realTimePricingProps.error) {
                        props.apiResult.products = props.apiResult.products!.map(product => {
                            product.properties["failedToLoadPricing"] = "true";
                            return product;
                        });
                    }
                    props.parameter.onSuccess?.(props.apiResult);
                },
            }),
        );
    }
};
addToChainAfter(chain, RequestDataFromApi, UpdatePrice);
